import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/views/layout/index.vue';
Vue.use(VueRouter);
export const asyncRoutes = [];
export const constantRoutes = [{
  path: '/',
  redirect: {
    name: 'login'
  }
},
{
  // 页面中转
  path: '/distributor',
  name: 'Distributor',
  component: () =>
            import ('@/views/distributor'),
  hidden: true
},
{
  path: '/login',
  name: 'login',
  component: () =>
            import ('@/views/login/index'),
  meta: { show: true }
},
{
  path: '/guideNotice',
  name: 'GuideNotice',
  component: Layout,
  children: [{
    path: '/guideNotice',
    component: resolve => require(['@/views/guideNotice/index'], resolve),
    meta: { title: '视导通知', showHeader: true, showLeft: false }
  }]
},
{
  path: '/feedbackReport',
  name: 'FeedbackReport',
  component: Layout,
  children: [{
    path: '/feedbackReport',
    component: resolve => require(['@/views/schoolProject/pages/export/detail'], resolve),
    meta: { title: '常规视导反馈报告', showHeader: true, showLeft: false }
  }]
},
{
  path: '/divisionNotice',
  name: 'divisionNotice',
  component: Layout,
  children: [{
    path: '/divisionNotice',
    component: resolve => require(['@/views/divisionNotice/index'], resolve),
    meta: { title: '专家确认通知', showHeader: true, showLeft: false }
  }]
}
];

const createRouter = () => new VueRouter({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});

const router = createRouter();

// 重置路由
export function resetRouter(router) {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // the relevant part
}

export default router;
